export default {
  nav: {
    findBarber: 'Find a Barber'
  },
  navigation: {
    home: 'Home',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    demo: 'Demo',
    login: 'Login',
    language: 'Language',
    logo: 'Logo',
    toggleMenu: 'Toggle Menu',
    changeLanguage: 'Change Language',
    scrollToTop: 'Scroll to top',
    joinAsBarber: 'Join as Barber',
    pricing: 'Pricing',
    signUp: 'Sign Up / Register'
  },
  home: {
    hero: {
      eyebrow: 'Now onboarding in Sofia - only 3 spots left this week',
      mainTitle: 'Your chair.<br>Your schedule.<br><span class="hero-title-accent">Your growth.</span>',
      growBusiness: 'I want more clients',
      seeDashboard: 'See the dashboard',
      trustText: '<strong>Petar Barbov</strong> and barbers across Europe are already on the platform.',
      joinThem: 'Join them →'
    },
    mobile: {
      label: 'Pocket Management',
      title: 'Manage your shop from anywhere.',
      desc: "Check your schedule, accept bookings, and see client history right from your phone.",
      list: [
        'Instant booking notifications',
        'Full client history',
        'Add walk-ins in seconds'
      ]
    },
    featuresList: [
      { title: 'Your own booking page', desc: 'A professional link for your Instagram bio and WhatsApp. Clients book themselves 24/7.' },
      { title: 'Smart calendar', desc: 'Block personal time, set working hours, and never double-book again.' },
      { title: 'Client database', desc: "History, notes, and contact details—organized and instantly searchable." },
      { title: 'International platform', desc: 'Supports EN, BG, HR, ALB, GER and growing.' }
    ],
    calendar_preview: {
      title: 'Your calendar, on any device.'
    },
    how: {
      label: 'How it works',
      title: 'Ready in under 10 minutes'
    },
    stepsList: [
      { title: 'Create Profile', desc: "Add your services, hours, and get your booking link instantly." },
      { title: 'Share Link', desc: 'Drop it in your Instagram bio or send to regulars. They book in seconds.' },
      { title: 'Show Up & Cut', desc: 'The calendar manages itself. You focus on your craft.' }
    ],
    testimonial: {
      quote: "Before Barbers Unity, I was losing 3-4 bookings a week just from missed calls. Now my calendar fills itself. I just show up and cut.",
      name: 'Petar Barbov',
      role: 'Professional Barber'
    },
    stats: {
      label: 'Platform activity',
      title: 'Growing every day',
      bookings: 'Bookings managed',
      clients: 'Clients served',
      time: 'Hours saved / week'
    },
    pricing: {
      label: 'Simple Pricing',
      title: 'One flat rate. No commissions.',
      period: 'Flat per month',
      desc: 'Other platforms punish your success with per-booking fees. We believe what you earn is strictly yours to keep.',
      featuresList: [
        'Unlimited reservations',
        'Zero hidden fees',
        'Full client data ownership'
      ]
    },
    faq: {
      label: 'Got questions?',
      title: 'Frequently Asked Questions'
    },
    faqList: [
      { q: "Do my clients need to download an app?", a: "No! They book through a fast, clean web link. No apps, no accounts." },
      { q: "How do I get paid?", a: "You keep 100%. Clients pay you directly in the shop just like always." },
      { q: "Am I locked into a contract?", a: "No. It's a flat month-to-month subscription. Cancel anytime." },
      { q: "Is it hard to switch platforms?", a: "It takes 0 effort. Send us your list and we import everything for free." }
    ],
    cta: {
      title: 'Ready to fill your calendar?',
      button: 'Get Started Now'
    }
  },
  about: {
    title: 'About Barbers Unity',
    description: "We are radically changing how barbers connect with their clients. Our platform helps barbers showcase their work, manage their schedules, and grow their businesses efficiently.",
    founded: 'Founded in 2025, Barbers Unity has grown from a simple idea into a complete platform serving barbers across multiple countries.',
    ourStory: 'Our Story',
    whatDrivesUs: 'What Drives Us',
    mission: {
      title: 'Our Mission',
      description: 'To simplify and modernize the booking process for barbers'
    },
    vision: {
      title: 'Our Vision',
      description: 'To create the largest community of connected barbers worldwide'
    },
    values: {
      title: 'Our Values',
      description: 'Quality, Trust, and Professional Growth'
    },
    built: {
      label: 'Built for the trade',
      title: 'We know what it’s like behind the chair.',
      desc1: "Barbers Unity wasn't built in corporate offices. It was built because we saw amazing barbers - talented, in-demand, respected - losing clients from unanswered calls and bad booking systems that weren't made for them.",
      desc2: "We built the platform we wished existed: one that takes your craft seriously, puts your name first, and handles the admin so you don't have to worry about it.",
      stats: {
        countries: 'Countries we operate in',
        time: 'To go live',
        cost: 'Setup cost'
      }
    },
    testimonial: {
      quote: "Before Barbers Unity, I was losing 3-4 bookings a week just from missed calls and WhatsApps I forgot to reply to. At €20 a cut, that's €240-320 I was losing every month. Now my calendar fills itself. I just show up and cut.",
      name: 'Petar Barbov',
      role: 'Professional Barber · Early Member'
    },
    timeline: {
      label: 'Timeline',
      title: 'Building something bigger.',
      items: [
        { year: '2025', event: 'Barbers Unity is founded - an idea born from the frustration of endless calls and missed appointments.' },
        { year: '2025', event: 'The platform launches in Beta.' },
        { year: 'Now', event: 'Expanding the network - more barbers, more cities, better tools for everyone.' }
      ]
    },
    cta: {
      eyebrow: 'Limited spots - book before they fill up',
      title: 'Want to be part of the story?',
      description: "Whether you are a barber or a client, there is always a place for you in the Barbers Unity community.",
      findBarber: 'Find a Barber',
      getInTouch: 'Get in Touch'
    }
  },
  contact: {
    title: 'Contact Us',
    getInTouch: {
      title: 'Get in Touch',
      description: 'Have questions about Barbers Unity? We are here to help! Message us on any of our social media channels or send us a message directly.',
      info: "Have questions about Barbers Unity? We are here to help - message us on any channel below."
    },
    followUs: 'Follow Us',
    b2b: {
      text: "<strong>Are you a barber?</strong> Skip the form - book a free 20-minute call and we will set everything up together.",
      button: 'Book a Free Call'
    },
    success: {
      title: 'Message Sent!',
      desc: "Thanks for reaching out. We will get back to you as soon as possible.",
      button: 'Send another'
    },
    form: {
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'your@email.com',
      message: 'Message',
      messagePlaceholder: 'Tell us how we can help...',
      send: 'Send Message'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Limited spots - now onboarding new barbers',
      mainTitle: 'Stop managing your business<br><span class="title-accent">manually.</span>',
      mainDesc: 'Every missed call is money slipping through your fingers. Every no-show burns a valuable slot. Barbers Unity gives you a professional system that keeps your calendar full and your clients informed.',
      bookCall: 'Book a Free Setup Call',
      seeDashboard: 'See the Dashboard',
      trust: ['Free setup', 'No contracts', 'Ready to work in 10 minutes']
    },
    loss: {
      beforeLabel: 'Without Barbers Unity',
      afterLabel: 'With Barbers Unity',
      without: [
        'Missing calls while cutting',
        'No-shows burning empty slots',
        'Confirming every booking by hand',
        'Messy notebooks or Excel sheets',
        'Not knowing which services bring the most profit'
      ],
      with: [
        'Clients book themselves online, 24/7',
        'Calendar updates instantly, zero effort',
        'Professional dashboard, always organized',
        'Full booking history and service reports',
        'Works across multiple countries and languages'
      ]
    },
    features: {
      label: 'What you get',
      heading: 'Everything a professional barber needs',
      items: [
        { title: 'Your professional booking page', desc: 'A clean link with your name you can share anywhere - Instagram bio, WhatsApp, Google. Clients see services, prices, free slots and book themselves. No calls, no endless messaging.', badge: 'Ready in minutes' },
        { title: 'A full calendar just for barbers', desc: 'Block off your break time, set working hours, manage different services with different lengths. See your whole week at a glance and never double-book.', badge: null },
        { title: 'Client history and preferences', desc: "Haircut history, contact details, and notes for every client - all organized. Know exactly what the client wants before they even sit in the chair.", badge: null },
        { title: 'Automated reminders (coming soon)', desc: 'Reminder messages via Email and WhatsApp will be sent automatically before every appointment. No-shows will disappear as a problem. Launching soon.', badge: 'Soon' }
      ]
    },
    why: {
      label: 'Why barbers choose us',
      heading: 'Your chair.<br>Your rules.<br>Your profit.',
      body: 'Barbers Unity puts your business in front of clients actively looking for a barber - without you having to ask them, chase them, or stress about it.',
      list: [
        'Zero client hunting - clients come to you',
        'Set up in a 20-minute call, completely free',
        'Works perfectly with your current WhatsApp and email',
        "No contracts - leave whenever you want (but you won't need to)",
        'Dedicated support from real people, not chatbots'
      ],
      highlights: [
        { title: 'Instant setup', desc: "A 20-minute call. You are ready to work before you hang up." },
        { title: 'Built for barbers', desc: 'Designed together with barbers - not just for them.' },
        { title: 'Multi-language', desc: 'EN, BG, HR, ALB, GER - wherever you work.' },
        { title: 'No contracts', desc: 'Start for free. Stay because it works, not because you have to.' }
      ]
    },
    testimonial: {
      quote: "Before Barbers Unity, I was losing 3-4 bookings a week just from missed calls and WhatsApps I forgot to reply to. At €20 a cut, that's €240-320 I was losing every month. Now my calendar fills itself. I just show up and cut.",
      name: 'Petar Barbov',
      role: 'Professional Barber · Early Member'
    },
    cta: {
      eyebrow: 'Onboarding in Sofia - only 3 spots left this week',
      mainTitle: 'Ready to have a fully booked schedule?',
      sub: "Book a free 20-minute call. We will set up everything together - your profile, services, and calendar. You will be ready to work before the call ends.",
      bookCall: 'Book My Free Call Now',
      member: 'Already a member?',
      login: 'Log in to your dashboard →'
    }
  },
  footer: {
    description: 'Connecting barbers with their clients, simplifying bookings, and growing businesses.',
    quickLinks: {
      title: 'Quick Links',
      about: 'About Us',
      contact: 'Contact',
      demo: 'Demo'
    },
    legal: {
      title: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service'
    },
    followUs: 'Follow Us',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. All rights reserved.'
  },
  tailwindMessage: "Tailwind CSS works in Vue 3! 🎉",
  clickMe: "Click here",
  previous: 'Back',
  notFound: {
    title: 'Page Not Found',
    description: "The page you are looking for doesn't exist or has been moved.",
    backHome: 'Back to Home'
  },
  cookies: {
    title: 'Cookie Settings',
    message: 'We use cookies to improve your experience, analyze site traffic, and provide tailored content. By continuing to use our site, you agree to our use of cookies.',
    decline: 'Decline',
    accept: 'Accept All'
  },
  map: {
    eyebrow: 'Find a Barber',
    heading: 'Barbers Near You',
    searchPlaceholder: 'Search by city or barber name...',
    loading: 'Loading map...',
    error: {
      title: 'Map failed to load',
      desc: 'There was a problem loading the map. Please try again.',
      retry: 'Retry'
    },
    results: 'results',
    result: 'result',
    bookNow: 'Book Now'
  },
  privacy: {
    intro: 'Welcome to Barbers Unity. We respect your privacy and are committed to protecting your personal data. This privacy policy informs you about how we look after your data when you visit our site, your privacy rights, and how the law protects you.',
    sections: {
      collect: {
        title: '1. Information we collect',
        desc: 'We may collect, use, store, and transfer different kinds of personal data about you, which we have grouped as follows:',
        items: [
          '<strong>Identity Data</strong> includes first name, last name, username, or similar identifier.',
          '<strong>Contact Data</strong> includes email address and phone numbers.',
          '<strong>Technical Data</strong> includes internet protocol (IP) address, browser type and version, time zone, and other technology on the devices you use to access this site.'
        ]
      },
      use: {
        title: '2. How we use your data',
        desc: 'We will only use your personal data when the law allows us to. Most commonly, we will use your data in the following circumstances:',
        items: [
          'Where we need to perform the contract we are about to enter into or have entered into with you (e.g., booking an appointment).',
          'Where it is necessary for our legitimate interests, and your interests or fundamental rights do not override those interests.',
          'Where we need to comply with a legal obligation.'
        ]
      },
      contact: {
        title: '3. Contact Us',
        desc: 'If you have any questions about this privacy policy or our practices, please write to us through our contact channels.'
      }
    }
  },
  pricing: {
    title: 'Simple Pricing',
    subtitle: 'One plan. Everything included. First month free.',
    price: '35',
    period: '/month',
    perSeat: 'per salon',
    trial: 'First month FREE',
    cta: 'Start Free Trial',
    ctaNote: 'No credit card required · Cancel anytime',
    demo: 'See live demo first',
    features: [
      'Unlimited bookings',
      'Automated email & SMS reminders',
      'QR code & story generator',
      'Multi-worker calendar',
      'Analytics dashboard',
      'Customer booking history',
      'Priority support via WhatsApp',
      'Custom barber profile page'
    ],
    guarantee: {
      title: 'No Risk',
      desc: 'Try for 30 days completely free. No contracts, no hidden fees.'
    },
    support: {
      title: 'Priority Support',
      desc: 'Dedicated onboarding and ongoing support via WhatsApp.'
    },
    noContract: {
      title: 'Month to Month',
      desc: 'Cancel whenever you want. No lock-in, no penalties.'
    },
    faq: {
      q1: 'What happens after the free trial?',
      a1: "After 30 days you'll be charged €35/month. You can cancel anytime before that at no cost.",
      q2: 'Can I add multiple barbers?',
      a2: 'Yes — you can add multiple workers to a single salon account, each with their own calendar and availability.',
      q3: 'Do you offer discounts for multiple locations?',
      a3: "Reach out via WhatsApp or the contact page and we'll work something out.",
      q4: 'Is there a setup fee?',
      a4: 'No setup fee, ever. We also help you onboard for free.'
    }
  },
  terms: {
    title: 'Terms of Service',
    intro: 'Welcome to Barbers Unity. By accessing or using our platform, you agree to be bound by these terms. Please read them carefully.',
    sections: {
      account: {
        title: '1. Account Registration',
        desc: 'You must provide accurate information when creating an account. You are responsible for safeguarding your login credentials.'
      },
      usage: {
        title: '2. Acceptable Use',
        desc: 'You agree not to misuse the platform, interfere with its normal operation, or attempt to access it using a method other than the interface we provide.'
      },
      fees: {
        title: '3. Subscription and Fees',
        desc: 'Our services are billed on a subscription basis. All fees are non-refundable unless required by law.'
      },
      liability: {
        title: '4. Limitation of Liability',
        desc: 'Barbers Unity is provided "as is". We shall not be liable for any indirect, incidental, or consequential damages arising from your use of the platform.'
      }
    }
  },
  loading: {
    title: 'Loading...',
    message: 'Please wait'
  },
  modal: {
    registerTitle: 'Choose Account Type',
    businessTitle: 'Register as a Business',
    businessDesc: 'Salon / Barber',
    customerTitle: 'Register as a Customer',
    customerDesc: 'Book appointments'
  }
}